import { cloneDeep } from 'lodash'
import { getFilters } from '../../views/people/children/api'

export default {
    state: {
        colGroups: [],
        filters: [],
        selectedFilter: {},
        managers: [],
        occupationGroups: [],
        departments: [],
        status: [],
    },
    mutations: {
        SET_COL_GROUPS(state, groups) {
            state.colGroups = groups
        },
        SET_FILTERS(state, filters) {
            state.filters = filters
        },
        SET_FILTER(state, filter) {
            state.selectedFilter = cloneDeep(filter)
        },
        SET_MANAGERS(state, managers) {
            state.managers = managers
        },
        SET_DEPARTMENTS(state, departments) {
            state.departments = departments
        },
        SET_OCCUPATION_GROUPS(state, occupationGroups) {
            state.occupationGroups = occupationGroups
        },
        SET_STATUS(state, status) {
            state.status = status
        },
    },
    actions: {
        setColGroups({ commit }, colGroups) {
            commit('SET_COL_GROUPS', colGroups)
        },

        getFilters({ commit }) {
            getFilters().then(res => {
                commit('SET_FILTERS', res)
            })
        },
        setFilter({ commit }, filter) {
            commit('SET_FILTER', filter)
        },
        filterManagers({ commit }, managers) {
            commit('SET_MANAGERS', managers)
        },
        filterOccupationGroups({ commit }, occupationGroups) {
            commit('SET_OCCUPATION_GROUPS', occupationGroups)
        },
        filterDepartments({ commit }, departments) {
            commit('SET_DEPARTMENTS', departments)
        },
        filterStatus({ commit }, status) {
            commit('SET_STATUS', status)
        },
    },
}
